export default __webpack_public_path__ + "static/media/buku.c6b432b2.png";